import { Modal, Row, Col } from "react-bootstrap";
import GradientButton from "../../../Core/GradientButton";

export default function InstallationPendingModal(props) {
	return 	<Modal show={ props.show }>
				<Modal.Header>
					<h3>
						Installation Pending
					</h3>
				</Modal.Header>
				<Modal.Body>
					<p>Your installation is still pending. You will be notified once this is complete. Please WhatsApp us on 087 056 1218 if you would like to query this.</p>
				</Modal.Body>
				<Modal.Footer className="d-block">
                    <Row className="d-flex justify-content-center">
                        <Col className="col-4">
					        <GradientButton title="OK" variant="greenYellow" onClick={() => props.onOKClicked()} />
                        </Col>
                    </Row>
				</Modal.Footer>
			</Modal>
}